var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { getAutomation } from '@citrus/runtime';
import { css as emotionCss, cx } from 'emotion';
import { isNotNilOrEmpty } from '@pcty/utils';
var VERSION = '5.5.1';
/** DISPLAY NAME: &lt;Flyout.Trigger&gt; */
var FlyoutTrigger = function (_a) {
    var _b;
    var automationId = _a.automationId, children = _a.children, className = _a.className, css = _a.css, _c = _a.__TYPE, __TYPE = _c === void 0 ? 'FlyoutTrigger' : _c;
    var classes = cx((_b = {},
        _b[emotionCss(css)] = isNotNilOrEmpty(css),
        _b), className || '');
    return (React.createElement("div", __assign({ className: classes }, getAutomation(automationId)), children));
};
FlyoutTrigger.defaultProps = {
    __TYPE: 'FlyoutTrigger',
};
export default FlyoutTrigger;
